__turbopack_context__.v({
  "container": "section-header-module__Rwd0zG__container",
  "heading": "section-header-module__Rwd0zG__heading",
  "highlight": "section-header-module__Rwd0zG__highlight",
  "subtitle": "section-header-module__Rwd0zG__subtitle",
  "text2xl": "section-header-module__Rwd0zG__text2xl",
  "text3xl": "section-header-module__Rwd0zG__text3xl",
  "text4xl": "section-header-module__Rwd0zG__text4xl",
  "text5xl": "section-header-module__Rwd0zG__text5xl",
  "text6xl": "section-header-module__Rwd0zG__text6xl",
  "text7xl": "section-header-module__Rwd0zG__text7xl",
  "text8xl": "section-header-module__Rwd0zG__text8xl",
  "text9xl": "section-header-module__Rwd0zG__text9xl",
  "textbase": "section-header-module__Rwd0zG__textbase",
  "textlg": "section-header-module__Rwd0zG__textlg",
  "textsm": "section-header-module__Rwd0zG__textsm",
  "textxl": "section-header-module__Rwd0zG__textxl",
  "textxs": "section-header-module__Rwd0zG__textxs",
  "white": "section-header-module__Rwd0zG__white",
  "word": "section-header-module__Rwd0zG__word",
});
